import axios from "@/api/axiosInstance";
import type {
  CreateSubscriptionRequest,
  CreateSubscriptionResponse,
} from "./types";

export const createSubscription = async (
  request: CreateSubscriptionRequest,
): Promise<CreateSubscriptionResponse> => {
  const response = await axios.post<CreateSubscriptionResponse>(
    "/api/private/subscriptions",
    request,
  );
  return response.data;
};
